export const ATTACHMENT_PARENT_TYPES = {
  PERSON: 'PERSON',
  VEHICLE: 'VEHICLE',
  ADDRESS: 'ADDRESS',
  PLACE: 'Place',
  ZONE: 'Zone',
};
